import { render, staticRenderFns } from "./FilterBlock.vue?vue&type=template&id=721f2010"
import script from "./FilterBlock.vue?vue&type=script&lang=js"
export * from "./FilterBlock.vue?vue&type=script&lang=js"
import style0 from "./FilterBlock.vue?vue&type=style&index=0&id=721f2010&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('721f2010')) {
      api.createRecord('721f2010', component.options)
    } else {
      api.reload('721f2010', component.options)
    }
    module.hot.accept("./FilterBlock.vue?vue&type=template&id=721f2010", function () {
      api.rerender('721f2010', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/elements/FilterBlock.vue"
export default component.exports